<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="container-fluid">

    <p *ngIf="!shipments" class="text-muted  text-center  mt-4" i18n>Indlæser ...</p>

    <button *ngIf="shipments && shouldShowBack()" (click)="back()" class="btn  btn-sm  btn-primary  mt-4" i18n>Go back
    </button>

    <table *ngIf="shipments" class="table  table-sm  mt-4">
        <thead>
        <tr>
            <th i18n>External reference</th>
            <th i18n>Order reference</th>
            <th i18n>Nota number</th>
            <th i18n>Order date</th>
            <th i18n>Shipping date</th>
            <th i18n>Adresse</th>
            <th></th>
        </tr>
        </thead>

        <tbody>
        <ng-template ngFor let-shipment [ngForOf]="shipments">
            <tr>
                <td>{{ shipment.external_reference }}</td>
                <td>{{ shipment.order_reference }}</td>
                <td>{{ shipment.nota_number }}</td>
                <td>{{ shipment.order_date.format('YYYY-MM-DD') }}</td>
                <td>{{ shipment.shipping_date.format('YYYY-MM-DD') }}</td>
                <td>{{ shipment?.shipment_address?.name_1_receiver}}, {{ shipment?.shipment_address?.adress_1_receiver}}
                    - {{ shipment?.shipment_address?.postal_code_receiver}}
                </td>
                <td class="text-end">
                    <button (click)="edit(shipment)" class="btn  btn-sm  btn-primary" i18n>Edit</button>
                </td>
            </tr>
        </ng-template>
        </tbody>
    </table>
</div>
